import { render } from "./PizzaIcon.vue?vue&type=template&id=522bb380"
import script from "./PizzaIcon.vue?vue&type=script&lang=js"
export * from "./PizzaIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__